export const URL = '/api/repair-cash-operation'
